import React from 'react';
import Badge from 'react-bootstrap/Badge';
import { statusPillClass } from '../domain/schema';

/**
 * StatusPill — outlined status badge using the app-global title-tag-badge pill classes.
 * Uses the design-system outlined pill: teal for steady states, amber for problem states.
 *
 * `icon` rides INSIDE the pill. Where two pills sit together and each says a different KIND of
 * thing — a run's status beside the exit it took — the glyph is what tells them apart, and outside
 * the pill it read as a separate element rather than as part of the value.
 */
function StatusPill({ status, icon }) {
  return (
    <Badge variant="secondary" className={statusPillClass(status)}>
      {icon && <span className="bh-pill-icon" aria-hidden="true">{icon}</span>}
      {status || 'unknown'}
    </Badge>
  );
}

export default StatusPill;
